module.exports = __webpack_public_path__ + "media/images/favicon7-e47575c70f5e27d299661732f477f17b.ico";